import { Action } from '@ngrx/store';

export class WealthEvolutionAction implements Action {

    public static getLastThreeMonthsHistory = '[Wealth Evolution] get_last_three_months_history';
    public static getLastThreeMonthsHistoryError = '[Wealth Evolution] get_last_three_months_history_error';
    public static getLastThreeMonthsHistorySuccess = '[Wealth Evolution] get_last_three_months_history_success';

    public static getLastSixMonthsHistory = '[Wealth Evolution] get_last_six_months_history';
    public static getLastSixMonthsHistoryError = '[Wealth Evolution] get_last_six_months_history_error';
    public static getLastSixMonthsHistorySuccess = '[Wealth Evolution] get_last_six_months_history_success';

    public static getLastOneYearHistory = '[Wealth Evolution] get_last_one_year_history';
    public static getLastOneYearHistoryError = '[Wealth Evolution] get_last_one_year_history_error';
    public static getLastOneYearHistorySuccess = '[Wealth Evolution] get_last_one_year_history_success';

    public static getLastThreeYearsHistory = '[Wealth Evolution] get_last_three_years_history';
    public static getLastThreeYearsHistoryError = '[Wealth Evolution] get_last_three_years_history_error';
    public static getLastThreeYearsHistorySuccess = '[Wealth Evolution] get_last_three_years_history_success';

    public static getFromBeginningHistory = '[Wealth Evolution] get_from_beginning_history';
    public static getFromBeginningHistoryError = '[Wealth Evolution] get_from_beginning_history_error';
    public static getFromBeginningHistorySuccess = '[Wealth Evolution] get_from_beginning_history_success';

    public static checkUserHasPosition = '[Wealth Evolution] check_user_has_position';
    public static checkUserHasPositionError = '[Wealth Evolution] check_user_has_position_error';
    public static checkUserHasPositionSuccess = '[Wealth Evolution] check_user_has_position_success';

    public static resetWealthEvolutionState = '[Wealth Evolution] reset_wealth_evolution_state';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
